let YourDailyRoutine = Backbone.Model.extend(
    {
        defaults:
            {
                beginDay: appConfig.dailyRoutine.begin.defaultValue,
                endDay: appConfig.dailyRoutine.end.defaultValue
            },

        getBeginDay: function () {
            return parseInt(this.get('beginDay'));
        },

        getEndDay: function () {
            return parseInt(this.get('endDay'));
        },

        updateTimes: function (beginDay, endDay) {
            beginDay = parseInt(beginDay);
            endDay = parseInt(endDay);
            if (beginDay !== this.getBeginDay() || endDay !== this.getEndDay()) {
                this.set('beginDay', beginDay);
                this.set('endDay', endDay);
            }
        },

        getBeginDayHour: function () {
            let min = this.getBeginDay()
            return Math.floor(min / 60);
        },

        getEndDayHour: function () {
            let min = this.getEndDay()
            return Math.ceil(min / 60);
        },

        getHoursUp: function () {
            let startHour = this.getBeginDayHour();
            let endHour = this.getEndDayHour();
            if (startHour < endHour) {
                return endHour - startHour;
            }
            return startHour - endHour;
        },

        getHoursAsleep: function () {
            return 24 - this.getHoursUp();
        }
    }
);
